module.exports = __webpack_public_path__ + "2718ff1159311f4ddf5b64f47b948e27.png";